import { createStandaloneToast } from '@chakra-ui/react'
const { toast } = createStandaloneToast()

export default toast
